
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SearchSection from './components/SearchSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import FeaturedPropertiesSection from './components/FeaturedPropertiesSection';
import TestimonialsSection from './components/TestimonialsSection';
import AreaInfoSection from './components/AreaInfoSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <SearchSection />
        <ServicesSection />
        <WhyChooseSection />
        <FeaturedPropertiesSection />
        <TestimonialsSection />
        <AreaInfoSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
